import {
  APPLY_JOB_ERROR_TOAST,
  CONNECTION_TOAST,
  CREAT_JOB_STATUS,
  DRAFT_END_URL,
  FILTER_ENDPOINT,
  LOGIN_DEFAULT_DETAILS,
  LOGOUT_ENDPOINT,
  OTP_RESEND_ENDPOINT,
  OTP_VERIFY_ENDPOINT,
  OTP_VERIFY_ENTERPRISE_ENDPOINT,
  RAZORPAY_CREATE_ORDER,
  RAZORPAY_ORDER_VALIDATE,
  RECOMMENDATIONS_ENDPOINT,
  SEARCH_END_URL,
  SMS_SENT_URL,
  SORT_IGNOR,
  GET_lOCATION_LIST,
  LOGIN_PASSWORD_VERIFY
} from '../constants/all'
import axios from 'axios'
import moment from 'moment'
import { APIGet, APIPost } from './ApiClient'
import { GET_POST_KEYS, NON_B2B_FIELDS, STEPS_IDS, STEP_WISE_KEYS_IN_POST_JOB, VARIANT_MAPPING } from '../constants/advertiser'
import { trackEvent } from '../analytics'
import { useContext } from 'react'
import { logoutMixpanelUser } from '@/config/mixpanel'
import { SharedContext } from '@/context/SharedContext'

export const seekersAnalayticOptions = (window, loginDetails, location, category, label) => {
  return {
    variant: window?.innerWidth > 640 ? 'desktop' : 'msite',
    mobile_number: loginDetails?.mobileNumber || '',
    location: location?.title || '',
    category,
    label
  }
}

export const advertiserAnalyticOptions = ({
  category = 'Tap',
  label = '',
  source = '',
  csat = false,
  enterprise = false,
  ...props
}) => {
  const isAndroidWebview = typeof Android != 'undefined'
  const variant = JSON.parse(localStorage.getItem('variant'))
  const loginDetails = JSON.parse(localStorage.getItem('loginDetails'))
  return {
    category,
    Platform: typeof Android != 'undefined' ? 'app' : 'Web',
    user_type: enterprise ? 'b2b' : 'b2c',
    device: window?.innerWidth > 640 ? 'desktop': 'mobile',
    ...(label ? { label } : {}),
    ...(source ? { source } : {}),
    ...(csat ? { user: 'advertiser', form_version: 'v2' } : {}),
    ...(isAndroidWebview
      ? {
          user: Android.getUserId(),
          app_version:
            typeof Android?.getAppVersionData == 'function' ? Android?.getAppVersionData() : ''
        }
      : {}),
      ...(variant ? { variant: VARIANT_MAPPING[variant]} : {}),
      ...(loginDetails?.mobileNumber ? { mobileNumber: loginDetails?.mobileNumber} : {}),
      ...(loginDetails?.id ? { userId: loginDetails?.id} : {}),
    ...props
  }
}

export const EmptyFunction = () => {}

export const getAppType = () => {
  if (typeof Android != 'undefined') {
    return 'jobs'
  } else {
    return 'web'
  }
}

export function parseAndroidToken(rawToken) {

  if (!rawToken) return { type: 'legacy', token: '' };

  if (typeof rawToken === 'object') {
    if (rawToken.token_type === 'jwt') {
      return { type: 'jwt', token: rawToken.token || '' };
    }
    return { type: 'legacy', token: rawToken.token || '' };
  }

  try {
    const parsed = JSON.parse(rawToken);
    if (parsed && parsed.token_type === 'jwt') {
      return { type: 'jwt', token: parsed.token || '' };
    }
    if (parsed && parsed.token) {
      return { type: 'legacy', token: parsed.token || '' };
    }
  } catch (e) {
    console.log(e)
  }

  return { type: 'legacy', token: rawToken };
}

const getUserToken = () => {
  if (typeof Android !== 'undefined') {
    const raw = Android.getUserToken(); 
    return raw;
  }
  return null;
}

export const getMethod = async ({
  url,
  headers = {},
  params = {},
  withstatusCode = false,
  isTokenPresent = true,
  isAndroidWebview = false,
  signal = null
}) => {
  axios.defaults.withCredentials = true

  if (process.env.NEXT_PUBLIC_APP_ENV === 'local' && isTokenPresent) {
    headers['Authorization'] = 'Token 622e184149b1be4da55cd767ca4dcd4619b9487f';
  }

  if (isAndroidWebview) {
    const rawToken = getUserToken(); 
    const { type, token } = parseAndroidToken(rawToken);

    if (token) {
      if (type === 'jwt') {
        headers['JWT-AUTHORIZATION'] = `Bearer ${token}`;
      } else {
        headers['Authorization'] = `${token}`;
      }
    }
  }

  const res = await axios
    .get(url, { headers, params, signal })
    .catch((error) => {
      if (axios.isCancel(error)) {
        return { isCanceled: true };
      }
      return { error: error?.response, isError: true };
    });

  if (withstatusCode) return res;
  return res?.data || {};
}

export const postMethod = async ({
  url,
  headers = {},
  params = {},
  data = {},
  withstatusCode = false,
  isTokenPresent = true,
  isAndroidWebview = false,
  advParameterFlag = false
}) => {
  axios.defaults.withCredentials = true;
  axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN'

  if (process.env.NEXT_PUBLIC_APP_ENV === 'local' && isTokenPresent && !advParameterFlag) {
    headers['Authorization'] = 'Token 622e184149b1be4da55cd767ca4dcd4619b9487f';
  }

  if (isAndroidWebview) {
    const rawToken = getUserToken();
    const { type, token } = parseAndroidToken(rawToken);

    if (token) {
      if (type === 'jwt') {
        headers['JWT-AUTHORIZATION'] = `Bearer ${token}`;
      } else {
        headers['Authorization'] = `${token}`;
      }
    }
  }

  const res = await axios({
    method: 'post',
    url,
    data,
    headers,
    params
  }).catch((error) => {
    return { error: error?.response, isError: true }
  })

  if (withstatusCode) return res
  return res?.data || {}
}

export const patchMethod = async ({
  url,
  headers = {},
  body = {},
  withstatusCode = false,
  isTokenPresent = true,
  isAndroidWebview = false,
}) => {
  axios.defaults.withCredentials = true

  if (process.env.NEXT_PUBLIC_APP_ENV === 'local' && isTokenPresent) {
    headers['Authorization'] = 'Token 622e184149b1be4da55cd767ca4dcd4619b9487f';
  }

  if (isAndroidWebview) {
    const rawToken = getUserToken();
    const { type, token } = parseAndroidToken(rawToken);

    if (token) {
      if (type === 'jwt') {
        headers['JWT-AUTHORIZATION'] = `Bearer ${token}`;
      } else {
        headers['Authorization'] = `${token}`;
      }
    }
  }

  const res = await axios
    .patch(url, body, { headers })
    .catch((error) => {
      return { error: error?.response, isError: true };
    });

  if (withstatusCode) return res;
  return res?.data || {};
}

export const multipleGetCalls = async (apiDetails) => {
  return await Promise.all(
    apiDetails?.map(async (item) => {
      return await getMethod({
        url: item?.url,
        params: item?.params,
        headers: item?.headers,
        ...item
      })
    })
  )
}

export const getPhoneNumberFromLocale = (locale = 'mr') => {
  if (locale == 'ta') {
    return '991032323232'
  }
  if (locale == 'mr') {
    return '7057704584'
  } else {
    return '7057704584'
  }
}

export const removeReference = (item) => {
  return JSON.parse(JSON.stringify(item))
}

export const getTheStatusOfRecruiterAlreadyPostedAJob = async () => {
  let isAndroidWebview = false
  if (typeof Android != 'undefined') {
    isAndroidWebview = true
  }
  const response = await getMethod({
    url: process.env.NEXT_PUBLIC_BASE_URL_ADS + '/submissions/submissions/first_time_advertiser',
    isAndroidWebview
  })
  return response
}

export const isOptionPresent = ({ list = [], searchValue, key }) => {
  let isPresent = false
  for (let element in list) {
    clog(list?.[element]?.[key])
    if (list?.[element]?.[key] == searchValue) {
      isPresent = true
      break
    }
  }
  return isPresent
}

export const optionHandler = async ({
  setSelectedOptions,
  selectedTitleId,
  buttonType,
  optionData,
  isDeskTop = false,
  beforeApplyHandler
}) => {
  let options = {}
  await setSelectedOptions((prv) => {
    let result = { ...prv }
    if (!result?.[selectedTitleId] || buttonType == 'radio') {
      result[selectedTitleId] = [removeReference(optionData)]
      options = { ...result }
      return { ...result }
    }
    if (
      isOptionPresent({ list: result[selectedTitleId], searchValue: optionData?.id, key: 'id' })
    ) {
      result[selectedTitleId] = result[selectedTitleId].filter((item) => item.id !== optionData?.id)
    } else {
      result[selectedTitleId].push(removeReference(optionData))
    }

    options = { ...result }
    return { ...result }
  })
  if (isDeskTop) beforeApplyHandler(options)
}

export const minAndMaxValueInList = (list = []) => {
  const min = Math.min(...list)
  const max = Math.max(...list)
  return { min, max }
}

export const getDropdownOptions = ({ type, data, stateId }) => {
  if (type === 'job_category' || type === 'salary') {
    if (Object.keys(data)?.length) {
      const categories = data[type].content_value.map((category) => ({
        title: category.title,
        id: category.id
      }))

      const sortedData = sortListBykeyInObject({ list: categories, key: 'title' })

      return { [type]: sortedData }
    }

    return {}
  }

  if (type === 'locations') {
    if (Object.keys(data)?.length) {
      const locations = data[type].states.filter((location) => location.state === stateId)

      const preferred_locations = locations?.map((location) => ({
        title: location.short_name,
        id: location?.id || 9
      }))

      const sortedData = sortListBykeyInObject({ list: preferred_locations, key: 'title' })

      return { [type]: sortedData }
    }

    return {}
  }
    
    return {}
}

export const sortListBykeyInObject = ({ list = [], key }) => {
  let sortedData = !Array?.isArray(list)
    ? []
    : list?.sort((item1, item2) => {
        if (item1?.[key]?.trim()?.toUpperCase() < item2?.[key]?.trim()?.toUpperCase()) {
          return -1
        }
        if (item1?.[key]?.trim()?.toUpperCase() > item2?.[key]?.trim()?.toUpperCase()) {
          return 1
        }
        return 0
      })
  return [...sortedData]
}

export const findPostOrFutureTime = (time) => {
  const presentTime = moment()
  const createdTime = moment(time)
  let minutes, hours, days, months, years
  minutes = presentTime.diff(createdTime, 'minutes')
  hours = presentTime.diff(createdTime, 'hours')
  days = presentTime.diff(createdTime, 'days')
  months = presentTime.diff(createdTime, 'months')
  years = presentTime.diff(createdTime, 'years')

  if (minutes == 0) return 'just now'
  if (minutes <= 60) return minutes + ' minutes'
  if (hours < 24 && hours != 0) return hours + ' hours'
  if (days < 30) return days + ' days'
  if (months < 12) return months + ' months'
  return years + ' years'
}

export const updateReviewStatus = async ({ leadId, classifiedId }) => {
  await patchMethod({
    url:
      process.env.NEXT_PUBLIC_BASE_URL_ADS +
      `/classifieds/classifieds/${classifiedId}/leads/${leadId}/update_review_status/`
  })
}

export const fetchContextData = async ({ cookie, setFormContext, isEnterprise = false }) => {
  const language = cookie.get('language')
  const location = cookie.get('location')
  const userState = cookie.get('userState')
  const params = {
    location_id: location?.id,
    en: 0
  }
  if (userState) params['state_id'] = userState
  if (isEnterprise) params['submission_type'] = 'enterprise'
  const res = await getMethod({
    url: process.env.NEXT_PUBLIC_BASE_URL_ADS + DRAFT_END_URL,
    params,
    headers: {
      'Accept-Language': language,
      'App-Type': 'web'
    },
    withstatusCode: true
  })
  const data = !!res?.data ? { ...res?.data } : {}
  setFormContext(data?.context || {})
}

export const fetchNextJobDetails = async ({
  jobDetails,
  pagination,
  setPagination,
  setRecommendations,
  language
}) => {
  const recommendationParams = {
    classified_id: jobDetails?.id,
    page: pagination.pageNumber + 1,
    location_id: 9
  }
  setPagination((prv) => ({ ...prv, pageNumber: prv.pageNumber + 1 }))
  const data = await getMethod({
    url: process.env.NEXT_PUBLIC_BASE_URL_ADS + RECOMMENDATIONS_ENDPOINT,
    params: recommendationParams,
    headers: { 'Accept-Language': language, source: 'jobs_web' }
  })
  if (data?.results?.length > 0)
    setRecommendations((prv) => {
      return [...prv, ...data.results]
    })
  else setPagination((prv) => ({ ...prv, hasMore: false }))
}

export const getFormattedBody = ({ data, user, step, keys, loginDetails = {}, isEnterprise = false }) => {
  let formdata = new FormData()
  if (user) formdata?.append('user', user)
  if (loginDetails?.mobileNumber) formdata?.append('phone_number', loginDetails?.mobileNumber)
  if (isEnterprise) formdata?.append('submission_type', 'enterprise')
  keys?.[step]?.forEach((key) => {
    if (data?.[key] !== null && data?.[key] !== '' && data?.[key] !== undefined) {
      if (Array.isArray(data?.[key])) {
        for (let i = 0; i < data?.[key]?.length; i++) {
          formdata?.append(key, data[key][i])
        }
      } else {
        formdata?.append(key, data?.[key])
      }
    }
  })
  return formdata
}

export const handleValidation = (requiredFields, data) => {
  const validations = requiredFields.map((item) => {
    const { field, array } = item
    if (array) {
      if (data[field]?.length) return false
      return true
    }

    if (data[field] !== null && data[field] !== '') return false
    return true
  })

  if (validations.every((e) => e === false)) return false
  return true
}

export const getFieldsId = (values, fieldsData, type) => {
  let arr = []
  if (Object.keys(fieldsData)?.length) {
    if (type === 'locations') {
      arr = values.map((value) => {
        const item = fieldsData[type]?.states?.find((field) => field.title === value)

        if (item) return { title: item.title, id: item.id }
      })
    } else {
      arr = values.map((value) => {
        const item = fieldsData[type]?.content_value?.find((field) => field.title === value)

        if (item) return { title: item.title, id: item.id }
      })
    }
  }

  return arr.filter(function (e) {
    return e
  })
}

export const fetchOptions = async ({
  selectedTitleId,
  setOptions,
  options,
  setLoader,
  language,
  pagination,
  setPagination
}) => {
  if (selectedTitleId == 2) {
    const params = { page: 1, type: 'all' }
    const response = await getMethod({
      url: `${process.env.NEXT_PUBLIC_BASE_URL_ADS}${GET_lOCATION_LIST}`,
      params
    })
    if (response?.results?.length > 0) {
      setOptions((prv) => {
        let results = { ...prv }
        results[2] = [
          ...response?.results?.map((item) => ({
            id: item.id,
            english_name: item.title,
            title: item.title_trans,
            filter_value: [item.id]
          }))
        ]
        return results
      })
    } else setPagination((prv) => ({ ...prv, hasMore: false }))
    setPagination((prv) => ({ ...prv, pageNumber: 2 }))
  } else {
    const url = process.env.NEXT_PUBLIC_BASE_URL_ADS + FILTER_ENDPOINT
    const params = { filter: selectedTitleId, location_id: 9, 'Accept-Language': language }
    const headers = { 'App-Type': 'web' }
    const isPresent =
      !Object.keys(options)?.includes(`${selectedTitleId}`) ||
      options?.[selectedTitleId]?.length <= 0
    if (isPresent) {
      setLoader(true)
      getMethod({ url, headers, params }).then((data) =>
        setOptions(
          (prv) => ({
            ...prv,
            [selectedTitleId]: SORT_IGNOR?.includes(selectedTitleId)
              ? data?.filters
              : sortListBykeyInObject({ list: data?.filters, key: 'title' })
          }),
          setLoader(false)
        )
      )
    }
  }
}

const isSelectedOptionsEmpty = (selectedOptions, keysToCheck) => {
  let isEmpty = true
  for (let item of keysToCheck) {
    if (selectedOptions?.[item]?.length > 0) {
      isEmpty = false
      break
    }
  }
  return isEmpty
}

export const findFilterValues = (list = []) => {
  let result = []
  if (list?.length > 0) {
    for (let item in list) {
      result?.push(...list?.[item]?.filter_value)
    }
  }
  return result
}

export const getAsPath = ({ selectedOptions, filterTitleIds }) => {
  const isCategorysPresent = selectedOptions?.[filterTitleIds['Job Category']]?.length > 0
  const isLocationsPresent =
    selectedOptions?.[filterTitleIds[process.env.NEXT_PUBLIC_LOCATION_NAME]]?.length > 0
  const isExperencePresent = selectedOptions?.[filterTitleIds['Experience']]?.length > 0
  const isSalaryPresent = selectedOptions?.[filterTitleIds['Salary']]?.length > 0

  const { location } = useContext(SharedContext)

  const keysToCheck = [
    filterTitleIds['Job Category'],
    filterTitleIds[process.env.NEXT_PUBLIC_LOCATION_NAME]
  ]

  if (
    isExperencePresent &&
    isSelectedOptionsEmpty(selectedOptions, [...keysToCheck, filterTitleIds['Salary']])
  )
    return `${
      selectedOptions?.[filterTitleIds['Experience']]?.[0]?.english_name
    }-years-experience-jobs`
      ?.replace(/ /g, '')
      ?.replace(/\//g, '-and-')
  if (
    isSalaryPresent &&
    isSelectedOptionsEmpty(selectedOptions, [...keysToCheck, filterTitleIds['Experience']])
  ) {
    const { min, max } = minAndMaxValueInList(
      findFilterValues(selectedOptions?.[filterTitleIds?.Salary])
    )
    return `salary-${min + '-' + max}-per-months-jobs`?.replace(/ /g, '')?.replace(/\//g, '-and-')
  }
  if (isCategorysPresent && isLocationsPresent) {
    const categories = selectedOptions[filterTitleIds['Job Category']]?.map((item) =>
      item?.title?.replace(/ /g, '').replace(/\//g, '-and-')
    )
    const locations = selectedOptions[filterTitleIds[process.env.NEXT_PUBLIC_LOCATION_NAME]]?.map(
      (item) => item?.title?.replace(/ /g, '')
    )
    return `${categories.join('-and-')}-jobs-in-${locations.join('-and-')}`
  }

  if (isCategorysPresent) {
    const categories = selectedOptions[filterTitleIds['Job Category']]?.map((item) =>
      item?.title?.replace(/ /g, '').replace(/\//g, '-and-')?.replace('&', '-and-')
    )
    // return `${categories.join('-and-')}-jobs/jobs-in-${location?.name || location?.title}`
    return `${categories.join('-and-')}-jobs-in-${location?.name || location?.title}`
  }

  if (isLocationsPresent) {
    const locations = selectedOptions[filterTitleIds[process.env.NEXT_PUBLIC_LOCATION_NAME]]?.map(
      (item) => item?.title?.replace(/ /g, '')
    )
    return `jobs-in-${locations.join('-and-')}`
  }

  return `jobs-in-${location?.name || location?.title}`
}

export const getAsPathLocationSelectionPage = ({ selectedOptions, filterTitleIds }) => {
  const isCategorysPresent = selectedOptions?.[filterTitleIds['Job Category']]?.length > 0
 
  const location = JSON.parse(localStorage.getItem('location'))

  if (isCategorysPresent) {
    const categories = selectedOptions[filterTitleIds['Job Category']]?.map((item) =>
      item?.title?.replace(/ /g, '').replace(/\//g, '-and-')?.replace('&', '-and-')
    )
    // return `${categories.join('-and-')}-jobs/jobs-in-${location?.name || location?.title}`
    return `${categories.join('-and-')}-jobs-in-${location?.name || location?.title}`
  }

  return `jobs-in-${location?.name || location?.title}`
}

export const getStorageValue = (key) => {
  const stored = localStorage.getItem(key)
  if (stored) return JSON?.parse(stored)
  return null
}

export const getSkeletonPathname = ({ router }) => {
  if (router.pathname === '/jobsFiltering') return 'jobsFiltering'
  if (router.pathname === '/seekerHomePage') return 'seekerHomePage'
  if (router.pathname === '/jobDetails') return 'jobDetails'
  return 'defaultLoader'
}

export const formattedUrl = (item = '', type = null) => {
  if (type === 'experience') return item.replace(/ /g, '')?.replace(/-/g, 'to')
  if (type === 'category')
    return item.replace(/ /g, '')?.replace(/\//g, '-and-')?.replace('&', '-and-')
  return item.replace(/ /g, '')
}

export const jobDetailsTitle = (jobDetails) => {
  return `${formattedUrl(jobDetails?.job_category || '', 'category')}-in-${formattedUrl(
    jobDetails?.job_location_slug || ''
  )}-with-${formattedUrl(
    jobDetails?.translated_content?.primary_details?.Experience || '',
    'experience'
  )} Job Id : ${jobDetails?.id} : Lokal App Jobs`
}

export const capitalizeFirstLetter = (text) => {
  return text?.charAt(0).toUpperCase() + text?.slice(1)
}

export const rediretionHandler = async ({
  link,
  buttonText,
  loginDetails,
  setLogInOpen,
  setLoading,
  setIsApplied,
  jobDetails,
  setShowToast,
  utmParams,
  window,
  location,
  id,
  source,
  type = 'call',
  isJobProfileCreated
}) => {
  if (!loginDetails?.isLogIn || !isJobProfileCreated) {
    if (!loginDetails?.isLogIn) {
      setLogInOpen(true)
    } else {
      return false
    }
  } else {
    if (buttonText === 'Apply') {
      setLoading(true)
      const res = await APIPost(`/classifieds/classifieds/${jobDetails?.id}/apply/?type=0`).catch(
        (error) => {
          clog(error)
        }
      )
      if (res) {
        trackEvent({
          name: 'tap_call',
          searchParams: {
            ...utmParams
          },
          options: {
            ...seekersAnalayticOptions(
              window,
              loginDetails,
              location,
              'conversion',
              'listings_page'
            ),
            classified_id: id,
            type,
            source,
            has_profile: true
          },
          isSeeker: true,
          conversion: true
        })
        setIsApplied(true)
      } else setShowToast(APPLY_JOB_ERROR_TOAST)
      setLoading(false)
    } else if (link) {
      window.open(link)
      trackEvent({
        name: 'tap_call',
        searchParams: {
          ...utmParams
        },
        options: {
          ...seekersAnalayticOptions(window, loginDetails, location, 'conversion', 'listings_page'),
          classified_id: jobDetails?.id,
          type,
          source,
          has_profile: true
        },
        isSeeker: true,
        conversion: true
      })
    }
  }
  return true
}

const resendHandler = async ({ isOnline, setShowToast, mobileNumber }) => {
  if (!isOnline) {
    setShowToast(CONNECTION_TOAST)
    return true
  }
  await postMethod({
    url: process.env.NEXT_PUBLIC_BASE_URL_API + OTP_RESEND_ENDPOINT,
    data: { mobile_no: mobileNumber }
  })
  return false
}

export const resendOtpHandler = async ({
  isOnline,
  setShowToast,
  mobileNumber,
  setOtpError,
  setOtp,
  setResendEnble,
  utmParams,
  isSeeker = false
}) => {
  const isError = await resendHandler({ isOnline, setShowToast, mobileNumber })
  if (!isError) {
    setOtpError({ isError: false, msg: '' })
    setOtp('')
    setResendEnble(false)
    if (!isSeeker) trackEvent({ name: 'resend_otp', searchParams: utmParams })
  }
}

const otpApiHandler = async ({
  isOnline,
  setShowToast,
  mobileNumber,
  otp,
  ischeckBoxClicked,
  platform = ''
}) => {
  if (!isOnline) {
    setShowToast(CONNECTION_TOAST)
    return
  }
  if (!Number(otp) || otp?.includes('.')) return { isLogedIn: false, msg: 'Please enter valid OTP' }
  const data = {
    mobile_no: mobileNumber,
    otp
  }
  if (!platform) {
    data['wa_optin'] = ischeckBoxClicked ? 1 : 0
  }
  const otpRes = await postMethod({
    url:
      process.env.NEXT_PUBLIC_BASE_URL_API +
      (platform ? OTP_VERIFY_ENTERPRISE_ENDPOINT : OTP_VERIFY_ENDPOINT),
    data: data
  })
  if (otpRes?.id) return { isLogedIn: true, data: otpRes }
  else return { isLogedIn: false, msg: otpRes?.message }
}

const passwordApiHandler = async ({
  isOnline,
  setShowToast,
  mobileNumber,
  password,
  ischeckBoxClicked,
  platform = ''
}) => {
  if (!isOnline) {
    setShowToast(CONNECTION_TOAST)
    return
  }
  const data = {
    mobile_no: mobileNumber,
    password
  }
  const passRes = await postMethod({
    url: process.env.NEXT_PUBLIC_BASE_URL_API + LOGIN_PASSWORD_VERIFY,
    data: data
  })
  if (passRes?.id) return { isLogedIn: true, data: passRes }
  else return { isLogedIn: false, msg: passRes?.message }
}

export const otpContinueHandler = async ({
  setLoading,
  setOtpError,
  translation,
  handleOtp,
  setLoginDetails,
  setEnterpriseLoginDetails = () => {},
  ischeckBoxClicked,
  handleModalClose,
  isOnline,
  setShowToast,
  cookie,
  mobileNumber,
  otp,
  trackEvent,
  loginTrack,
  utmParams,
  isSeeker = false,
  loginDetails,
  location,
  platform = ''
}) => {
  if (otp?.length != 4) {
    setOtpError({
      isError: true,
      msg: 'Please enter OTP'
    })
    return false
  }
  setLoading(true)
  const otpRes = await otpApiHandler({
    isOnline,
    setShowToast,
    mobileNumber,
    otp,
    ischeckBoxClicked,
    platform
  })

  if (!otpRes?.isLogedIn) {
    setOtpError({
      isError: true,
      msg: otpRes?.msg || translation?.pleaseTryAgain
    })
    if (!isSeeker) trackEvent({ name: 'otp_verification_failed', searchParams: utmParams })
    setLoading(false)
    return false
  } else {
    setOtpError({ isError: false, msg: '' })
    handleOtp('')
    if (otpRes?.data?.advertiser_id) {
      setEnterpriseLoginDetails((prv) => ({
        ...prv,
        advertiserId: otpRes?.data?.advertiser_id,
        companyName: otpRes?.data?.company_name,
        email: otpRes?.data?.email,
        companyAddress: otpRes?.data?.company_address,
        name: otpRes?.data?.name
      }))
    }
    setLoginDetails((prv) => ({
      ...prv,
      mobileNumber,
      isLogIn: true,
      id: otpRes?.data?.id
    }))

    cookie.set('user', otpRes?.data?.id, { path: '/' })
    setLoading(false)
    if (!isSeeker)
      trackEvent({
        name: 'otp_verification_successful',
        searchParams: utmParams,
        options: {
          lokal_user_id: otpRes?.data?.id,
          user_type: otpRes?.data?.advertiser_id ? 'b2b' : 'b2c',
          mobile_number: mobileNumber || loginDetails?.mobileNumber
        }
      })
    else
      trackEvent({
        name: 'seeker_login_successful',
        searchParams: {
          ...utmParams
        },
        options: seekersAnalayticOptions(
          window,
          {
            mobileNumber
          },
          location,
          'conversion',
          'seeker_login_page'
        ),
        isSeeker: true,
        conversion: true
      })
    loginTrack({ id: otpRes?.data?.id, mobileNumber })    
    handleModalClose(true)
    return true
  }
}

export const passwordContinueHandler = async ({
  setLoading,
  setError,
  setLoginDetails,
  setEnterpriseLoginDetails,
  isOnline,
  setShowToast,
  cookie,
  mobileNumber,
  password,
  loginTrack,
  platform = ''
}) => {
  setLoading(true)
  const otpRes = await passwordApiHandler({
    isOnline,
    setShowToast,
    mobileNumber,
    password,
    platform
  })

  if (!otpRes?.isLogedIn) {
    setError((prv) => ({
      ...prv,
      ['password']: {
        ...prv['password'],
        isPresent: true,
        msg: otpRes?.msg || 'Please try again'
      }
    }))
    setLoading(false)
    return false
  } else {
    setError((prv) => ({
      ...prv,
      ['password']: { ...prv['password'], isPresent: false, msg: '' }
    }))
    if (otpRes?.data?.advertiser_id) {
      setEnterpriseLoginDetails((prv) => ({
        ...prv,
        advertiserId: otpRes?.data?.advertiser_id,
        companyName: otpRes?.data?.company_name,
        email: otpRes?.data?.email,
        companyAddress: otpRes?.data?.company_address,
        name: otpRes?.data?.name
      }))
    }
    setLoginDetails((prv) => ({
      ...prv,
      mobileNumber,
      isLogIn: true,
      id: otpRes?.data?.id
    }))

    cookie.set('user', otpRes?.data?.id, { path: '/' })
    setLoading(false)
    loginTrack({ id: otpRes?.data?.id, mobileNumber })
    return true
  }
}

export const validateSteps = ({ presentStep, formData, enterpriseAdvertiserId = '' }) => {
  let ids = []
  const conditions = JSON?.parse(process.env.NEXT_PUBLIC_COMPONENT_SHOW)
  for (let item of STEPS_IDS?.[presentStep - 1]) {
    if (NON_B2B_FIELDS?.[item?.id] && enterpriseAdvertiserId) {
    } else if (item?.require) {
      if (item?.additionalCondition) {
        if (
          (formData?.['salary_max'] < formData?.['salary_min'] ||
            formData?.['salary_max'] < 1000 ||
            formData?.['salary_min'] < 1000 ||
            formData?.['salary_max'] > 100000 ||
            formData?.['salary_min'] > 100000) &&
          (item?.id === 'salary_max' || item?.id === 'salary_min')
        ) {
          ids.push(item?.id)
          continue
        }

        if (
          (formData?.['fee_amount'] > 2147483647 || Number(formData?.['fee_amount']) <= 0) &&
          item?.id == 'fee_amount' &&
          eval(item?.additionalCondition)
        ) {
          ids.push(item?.id)
          continue
        }
        if (
          item?.id === 'posting_locations' &&
          (formData?.['posting_locations']?.length == 0 || !formData?.['posting_locations'])
        ) {
          ids.push(item?.id)
          continue
        }
        if (
          (eval(item?.additionalCondition) &&
            (formData?.[item?.id]?.length <= 0 ||
              !formData?.[item?.id] ||
              formData?.[item?.id] === '0') &&
            !Number.isInteger(
              formData?.[item?.id] || (item?.orCondition && eval(item?.orCondition))
            )) ||
          (eval(item?.additionalCondition) &&
            item?.isMobileNumber &&
            formData?.[item?.id]?.length != 10)
        ) {
          ids.push(item?.id)
          continue
        }
      } else if (
        ((formData?.[item?.id]?.length <= 0 || !formData?.[item?.id]) &&
          !Number.isInteger(formData?.[item?.id])) ||
        (item?.isMobileNumber && formData?.[item?.id]?.length != 10) ||
        (item?.orCondition && eval(item?.orCondition))
      ) {
        if (item?.id === 'is_consultancy_name' && formData?.[item?.id] === false) {
          continue
        }
        ids.push(item?.id)
        continue
      }
    }
  }
  return [...ids]
}

const listToCommaSeparator = (list) => (Array?.isArray(list) ? list : [])?.join(',')

const findSubmitData = (formData) => {
  let temp = {}
  Object?.keys(GET_POST_KEYS[1])?.map((item) => {
    temp[GET_POST_KEYS[1][item]] = formData?.[item] || ''
  })
  temp['assets'] = temp?.['assets']?.length ? JSON.stringify(temp['assets']) : temp['assets']
  temp['preferred_languages'] = temp?.['preferred_languages']?.length
    ? JSON.stringify(temp['preferred_languages'])
    : temp['preferred_languages']
  return temp
}

export const draftPost = async ({ step, formData, isAndroidWebview,locale='en', isEnterprise = false }) => {
  const locationdata = localStorage.getItem('location')
  let location = JSON?.parse(locationdata)
  let data = JSON?.parse(JSON?.stringify(formData))
  let result = findSubmitData(data)
  result['platform'] = 'web'
  result['page-no'] = step
  const params = {
    location: location?.id,
    en:0,
    locale
  }
  await postMethod({
    url: process.env.NEXT_PUBLIC_BASE_URL_ADS + DRAFT_END_URL,
    headers: { 'App-Type': 'web' },
    params,
    data: getFormattedBody({ data: result, step, keys: STEP_WISE_KEYS_IN_POST_JOB, isEnterprise }),
    isAndroidWebview: typeof Android != 'undefined'
  })
}

export const getEventName = ({ presentStep, key }) => {
  if (presentStep === 1)
    return key === 'error' ? 'incomplete_job_details_page' : 'tap_next_job_details'
  if (presentStep === 2)
    return key === 'error'
      ? 'incomplete_candidate_requirement_page'
      : 'tap_next_candidate_requirements'
  if (presentStep === 3) return key === 'error' ? 'incomplete_company_details_page' : ''
  return ''
}

export const filterListOfObjects = ({ list = [], key = '', searchValue = '' }) => {
  return list.filter((item) =>
    String(item?.[key])?.toUpperCase()?.includes(String(searchValue).toUpperCase())
  )
}
export const structureIds = (data) => {
  const result = {}
  if (Array.isArray(data?.filters)) {
    data?.filters?.forEach((element) => {
      result[element?.english_name] = element?.id
    })
  }
  return result
}

export const redirectHandler = async (item, setBody, filterTitleIds) => {
  setBody({ apiBody: {}, selectedOptions: {} })
  const bodyValue = { [filterTitleIds['Job Category']]: [item] }
  setBody((prv) => ({
    ...prv,
    selectedOptions: bodyValue
  }))
}

const createApiBody = (selectedOptions) => {
  let result = {}
  for (let key in selectedOptions) {
    result[key] = findFilterValues(selectedOptions[key])
  }
  return result
}

export const applyHandler = async (
  selectedOptions,
  redirect = true,
  filterTitleIds,
  setBody,
  router,
  setCurrentPage = () => {}
) => {
  if (Object.keys(selectedOptions).length <= 0) {
    router.query = {}
  }
  const apiBody = createApiBody(selectedOptions)
  if (apiBody?.[filterTitleIds?.Salary]) {
    const { min, max } = minAndMaxValueInList(apiBody?.[filterTitleIds?.Salary])
    if (min !== Infinity && max !== -Infinity) {
      apiBody[filterTitleIds?.Salary] = [min, max]
    }
  }
  setBody((prv) => ({ ...prv, apiBody, selectedOptions }))
  setCurrentPage(0)
}
export const redirect = async ({ loginDetails, cookie, setShowToast, setIsJobProfileCreated }) => {
  if (loginDetails?.isLogIn) {
    const user = await cookie.get('user')
    const res = await getMethod({
      url: process?.env?.NEXT_PUBLIC_BASE_URL_ADS + CREAT_JOB_STATUS + `${user}/status/`,
      headers: { 'App-Type': 'web' }
    })
    if (res?.isError) {
      setShowToast({
        isVisible: true,
        details: {
          content: 'Something went to wrong',
          title: 'info',
          timeOut: 3000,
          placement: 'top'
        }
      })
    } else if (res?.status == 2) {
      setIsJobProfileCreated(true)
    } else {
      setIsJobProfileCreated(false)
      return false
    }
  }
  return true
}

export const logOutHandler = async ({
  utmParams={},
  window={},
  loginDetails={},
  location={},
  cookie={},
  setLoginDetails=()=>{},
  setEnterpriseLoginDetails=()=>{},
  isHire=false,
  setIsJobProfileCreated=()=>{}
}) => {
  try{
  await postMethod({ url: process.env.NEXT_PUBLIC_BASE_URL_API + LOGOUT_ENDPOINT })
  if (!isHire) {
    trackEvent({
      name: 'seeker_logged_out',
      searchParams: {
        ...utmParams
      },
      options: seekersAnalayticOptions(window, loginDetails, location, 'tap', 'seeker_home_page'),
      isSeeker: true
    })
  }
  if (isHire) {
    setUserType('');
    logoutMixpanelUser()
  }
  cookie && cookie.remove && cookie.remove('auth_cookie')
  cookie && cookie.remove && cookie.remove('user')
  setLoginDetails(LOGIN_DEFAULT_DETAILS)
  setEnterpriseLoginDetails({})

  }catch(err)
  {
    console.log("error from logout api",err)
  }

}

export const clog = (...value) => {
  if (
    process?.env?.NEXT_PUBLIC_APP_ENV === 'local' ||
    process?.env?.NEXT_PUBLIC_APP_ENV === 'staging'
  ) {
    return { ...value }
  }
}

export const getFooterAsPath = (header, title, translation) => {
  const {location} = useContext(SharedContext)
  if (header === translation.quickAccessFooterFields.jobsByLocation) {
    return `/jobs/jobs-in-${title}`
  } else if (header === translation.quickAccessFooterFields.categoryWiseJobs) {
    return `/jobs/${(title)
      .replace(/ /g, '')
      ?.replace(/\//g, '-and-')
      ?.replace('&', '-and-')}-jobs-in-${location?.name || location?.title}`
  } else if (title === translation.findAJob) {
    return `/jobs/jobs-in-${location?.name || location?.title}`
  } else if (title === translation.createAnAccount) {
    return '/jobs'
  } else if (title === translation.postAJob) {
    return '/jobs'
  }
}

export const appLinkSentHandler = async (mobile_no, setSuccessModal, setErrorPresent) => {
  const res = await postMethod({
    url: process.env.NEXT_PUBLIC_BASE_URL_ADS + SMS_SENT_URL,
    data: { mobile_no },
    withstatusCode: true
  })
  if (res?.status >= 200) {
    setSuccessModal(true)
  } else {
    setErrorPresent(true)
  }
}

export const createRazorPayOrder = async (
  amount,
  profile_id,
  package_id,
  advertiser_id,
  totalDistricts = 0
) => {
  let formData = new FormData()
  formData.append('amount', amount * 100) //In Paise
  formData.append('submission_type', 3)
  formData.append('profile_id', profile_id)
  formData.append('package_id', package_id)
  formData.append('notes', { advertiser_id: advertiser_id })
  if (totalDistricts) formData.append('total_districts', totalDistricts)
  const res = await postMethod({
    url: process.env.NEXT_PUBLIC_BASE_URL_ADS + RAZORPAY_CREATE_ORDER,
    data: formData
  })
  return res
}

export const getCsatEvent = (title) => {
  if (title.toLowerCase() == 'longer time to get job live') return 'tap_longer_time_to_get_job_live'
  if (title.toLowerCase() == 'not getting relevant leads') return 'tap_not_getting_relevant_leads'
  if (title.toLowerCase() == 'not able to find right candidates')
    return 'tap_not_able_to_find_right_candidates'
  if (title.toLowerCase() == 'app web is complex') return 'tap_app_web_is_complex'
  if (title.toLowerCase() == 'support from lokal team') return 'tap_support_from_lokal'
  return null
}

export const validateRazorPayOrder = async (
  razorpay_payment_id,
  razorpay_orderId,
  razorpay_signature,
  totalDistricts = 0
) => {
  let formData = new FormData()
  formData.append('razorpay_payment_id', razorpay_payment_id) //In Paise
  formData.append('user_role', 9)
  formData.append('order_row_id', razorpay_orderId)
  formData.append('razorpay_signature', razorpay_signature)
  if (totalDistricts) formData.append('total_districts', totalDistricts)
  const res = await postMethod({
    url: process.env.NEXT_PUBLIC_BASE_URL_ADS + RAZORPAY_ORDER_VALIDATE,
    data: formData
  })
  return res
}

export const numberWithCommas = (num) => {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const formatTimeAgo = (timestamp) => {
  const now = new Date()
  const date = new Date(timestamp)
  const diffTime = Math.abs(now - date)
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

  if (diffDays === 1) {
    return '1 day ago'
  } else if (diffDays === 30) {
    return '30 days ago'
  } else if (diffDays > 30) {
    const diffMonths = Math.floor(diffDays / 30)
    return `${diffMonths} months ago`
  } else {
    return `${diffDays} days ago`
  }
}

export const getFormattedLeadsData = (data) => {
  let leads = []
  if (!data?.length) return { leads }
  data?.forEach((item) => {
    const formattedData = {}
    formattedData['name'] = item.job_seeker.user_name
    formattedData['mobile_no'] = item.job_seeker?.user_number
    formattedData['gender'] = item.job_seeker?.gender?.title
    formattedData['qualification'] = item.job_seeker?.qualification?.value
    formattedData['experience'] = item.job_seeker?.experience?.value
    formattedData['classified'] = item.classified
    formattedData['user'] = item.job_seeker?.user
    formattedData['user_location'] = ''
    formattedData['id'] = item?.id

    leads.push(formattedData)
  })
  return { leads: leads }
}

export const getFormattedDatabaseCandidates = (data, classifiedId) => {
  let leads = []
  if (!data?.length) return { leads }
  data?.forEach((item) => {
    const formattedData = {}
    formattedData['name'] = item?.[1]?.name
    formattedData['mobile_no'] = item?.[1]?.mobile_no
    formattedData['gender'] = item?.[1]?.gender
    formattedData['qualification'] = item?.[1]?.qualification
    formattedData['experience'] = item?.[1]?.experience
    formattedData['classified'] = item?.[1]?.classified
    formattedData['user'] = item?.[0]
    formattedData['user_location'] = ''
    formattedData['id'] = item?.[1]?.id
    formattedData['classified'] = classifiedId

    leads.push(formattedData)
  })
  return { leads: leads }
}

export const getStep4PhoneNumberFromLocale = (locale = 'en') => {
  if (locale == 'ta') return '84288 17587'
  if (locale == 'mr') return '70577 04584'
  if (locale == 'kn') return '99891 71549'
  
  return '91601 34264'
}

export const getDateStringInIST = () => {
  const now = new Date()
  const options = {
    timeZone: 'Asia/Kolkata',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }
  return new Intl.DateTimeFormat('en-CA', options).format(now) // 'YYYY-MM-DD'
}
export const getDateStringFromISOInIST = (isoDateString) => {
  const date = new Date(isoDateString)
  const options = {
    timeZone: 'Asia/Kolkata',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }
  return new Intl.DateTimeFormat('en-CA', options).format(date) // 'YYYY-MM-DD'
}
export const getOverallCounts = () => {
  if (typeof window === 'undefined') return {} // For SSR
  const counts = localStorage.getItem('overallPendingJobCounts')
  return counts ? JSON.parse(counts) : {}
}
export const saveOverallCounts = (counts) => {
  if (typeof window === 'undefined') return
  localStorage.setItem('overallPendingJobCounts', JSON.stringify(counts))
}
export const getPendingJobCounts = () => {
  if (typeof window === 'undefined') return {} // For SSR
  const counts = localStorage.getItem('pendingJobCounts')
  return counts ? JSON.parse(counts) : {}
}
export const savePendingJobCounts = (counts) => {
  if (typeof window === 'undefined') return
  localStorage.setItem('pendingJobCounts', JSON.stringify(counts))
}
export const getPostedOnTime = (timeString) => {
  const time = moment(timeString)
  return time.format('D MMM, YYYY')
}

export const shouldShowApplicants = (status, selectedJob, variant) => {
  return status !== 'rejected' && (selectedJob?.classified || variant === 'pay_later');
};
